import styled from 'styled-components';


const DefaultContainer = styled.div<{ backgroundColor?: string, align?: string }>`
  background-color: ${({ theme, backgroundColor }) => backgroundColor ?? theme.colors.white};
  padding: 60px 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({ align }) => align ?? 'center'};
  flex-wrap: wrap;
  min-height: 250px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    padding: 60px 70px;
  }
`;

export default DefaultContainer;
